var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1WindowClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 53V19H20v34h-5v4h46v-4h-5zm-4-17H40V23h12v13zM24 23h12v13H24V23zm0 17h12v13H24V40zm16 13V40h12v13H40z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Window_close.cd9d7657.svg";
export { SvgC1WindowClose as ReactComponent };